import * as React from 'react';
import {BaseError, IBaseErrorProps} from './base-error';

export type I404Props = Omit<IBaseErrorProps, 'iconName' | 'title'>

export const Error404 = (props: I404Props) => (
    <BaseError
        iconName="face-pensive"
        title="404 - Not Found"
        message={props.message}
    />
);